module.exports = __webpack_public_path__ + "media/victory+good.a487a58b.mp3";